import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import isEqual from 'lodash/isEqual'
import withType from 'components/common/hoc/withType'
import chosen from 'components/common/hoc/chosen'
import { getPreviousPageUrl } from 'selectors/navigations'
import { setVehiclesList, setIsTrailer, makeActiveVehicle, setAppointmentActiveVehicle } from '../actions'
import BOTVehicleSelector from './BOTVehicleSelector'
import { getQuickAppointmentStepper } from 'components/Appointment/selectors'
import { isApptConfirmationPage } from 'helpers/quoteRelatedPages'

const withVehicleSelectorLoadingState = withState('vehicleSelectorIsLoading', 'setVehicleSelectorIsLoading', false)

const mapStateToProps = ({
  appointment: {
    isTrailer
  } = {},
  ...state
}, {
  UserVehicleDetails: {
    userVehicle
  } = {}
}) => ({
  isTrailer,
  vehicles: userVehicle || [],
  quickAppointmentStepper: getQuickAppointmentStepper(state),
  previousPage: getPreviousPageUrl(state)
})

export default compose(
  withType({ type: 'BOTVehicleSelector' }),
  chosen(),
  withVehicleSelectorLoadingState,
  connect(mapStateToProps, { setVehiclesList, setIsTrailer, makeActiveVehicle, setAppointmentActiveVehicle }),
  lifecycle({
    componentDidMount() {
      const { vehicles, previousPage, setVehiclesList, setIsTrailer, quickAppointmentStepper } = this.props

      if (vehicles) {
        setVehiclesList(vehicles)
      }

      if (!quickAppointmentStepper && !isApptConfirmationPage(previousPage)) {
        setIsTrailer(false)
      }
    },
    UNSAFE_componentWillReceiveProps({ vehicles, setVehiclesList }) {
      if (!isEqual(this.props.vehicles, vehicles)) {
        setVehiclesList(vehicles)
      }
    }
  })
)(BOTVehicleSelector)
